import { lazy } from "react";
import { defineWebModule } from "@tc/ui";
import { manifest } from "./manifest.js";

const CompliancePage = lazy(() => import("./web/CompliancePage.js").then((m) => ({ default: m.CompliancePage })));
const SettingsPage = lazy(() => import("./web/SettingsPage.js").then((m) => ({ default: m.SettingsPage })));
const ImportPage = lazy(() => import("./web/ImportPage.js").then((m) => ({ default: m.ImportPage })));
const UploadPage = lazy(() => import("./web/UploadPage.js").then((m) => ({ default: m.UploadPage })));

export default defineWebModule({ manifest, pages: { "": CompliancePage, "/upload": UploadPage, "/settings": SettingsPage, "/import": ImportPage } });
